export default __webpack_public_path__ + "static/media/OeloLogo.297cfff5.png";